import React, { Component } from 'react'
import ConfirmCode from './confirmCode.jsx'
import SendPhoneNumber from './sendPhoneNumber.jsx'
import GetSMSCode from './getSMSCode.jsx'
import ConfirmPhone from './confirmPhone.jsx'
import ChangePhoneNumber from './changePhoneNumber.jsx'
import { formatPhoneNumberIntl } from 'react-phone-number-input'

export default class PhoneNumber extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentData: {},
            confirmPhone: false,
            phoneCode: '',
            removePhone: false,
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    componentDidMount() {
        this.changePhoneNumberParams()
    }

    componentDidUpdate(prevProps, prevState) {
        this.changePhoneNumberParams(prevProps)
    }

    changePhoneNumberParams = prevProps => {
        let { currentData: propsCurrentData } = this.props
        let { value } = propsCurrentData
        let currentData = {}
        if (
            prevProps === undefined ||
            prevProps.currentData['value'] !== value
        ) {
            currentData = Object.assign({}, propsCurrentData, {
                value: formatPhoneNumberIntl('+' + value),
            })
            this.setState({
                currentData: currentData,
            })
        }
    }

    render() {
        return (
            <div className="phone-number">
                {this.handleChangePhoneNumberComponent()}
                {this.handleGetSMSCodeComponent()}
                {this.handleConfirmPhoneComponent()}
                {this.state.removePhone
                    ? this.handleSendPhoneNumberComponent()
                    : null}
            </div>
        )
    }

    inputFocus = ref => {
        this.nameInput = ref
    }

    handleChangePhoneNumberComponent = () => {
        let { currentData } = this.state
        let { currentData: propsCurrentData } = this.props

        return (
            <ChangePhoneNumber
                currentData={currentData}
                propsCurrentData={propsCurrentData}
                handlePhoneNumberChange={this.handlePhoneNumberChange}
            />
        )
    }

    handleConfirmPhoneComponent = () => {
        let { confirmPhone, phoneCode } = this.state
        let { phoneVerificationRequired } = this.props

        if (!confirmPhone && !phoneVerificationRequired) return null
        return (
            <ConfirmPhone
                phoneCode={phoneCode}
                handlePhoneNumberChange={this.handlePhoneNumberChange}
                inputFocus={this.inputFocus}
                handleConfirmCodeComponent={this.handleConfirmCodeComponent}
            />
        )
    }

    handleConfirmCodeComponent = event => {
        let { confirmPhone, phoneCode } = this.state
        let { dataProtection } = this.props
        return ConfirmCode({
            confirmPhone: confirmPhone,
            phoneCode: phoneCode,
            dataProtection: this.props.dataProtection,
            handlePhoneNumberChange: this.handlePhoneNumberChange,
        })
    }

    handleGetSMSCodeComponent = () => {
        let { currentData } = this.state
        if (!currentData.value) return null

        return GetSMSCode({
            currentData: currentData,
            propsCurrentData: this.props.currentData,
            sendPhoneNumber: this.handleSendPhoneNumberComponent,
        })
    }

    handleSendPhoneNumberComponent = () => {
        let { confirmPhone, currentData, removePhone } = this.state
        let { dataProtection } = this.props
        return SendPhoneNumber({
            confirmPhone: confirmPhone,
            currentData: currentData,
            removePhone: removePhone,
            dataProtection: this.props.dataProtection,
            nameInput: () => {
                this.nameInput.inputElement.focus()
            },
            handlePhoneNumberChange: this.handlePhoneNumberChange,
        })
    }

    handlePhoneNumberChange = (type, event) => {
        let state = Object.assign({}, this.state)
        type.forEach(param => {
            switch (param) {
                case 'phoneNumber':
                    state.currentData['value'] =
                        event !== undefined ? event : ''
                    break
                case 'phoneCode':
                    state.phoneCode =
                        event !== undefined
                            ? event.target.value.replace(/[^A-Z|0-9]/gi, '')
                            : ''
                    break
                case 'confirmPhone':
                    state.confirmPhone = !state.confirmPhone
                    break
                case 'removePhone':
                    state.removePhone = !state.removePhone
                    break
            }
        })
        this.setState({ ...state })
    }
}
